import React, { useState, useEffect, useRef } from 'react';
import './style.scss';

import { EntityTypeEnum } from './InteractionDrawer.types';

import { Button } from 'react-bootstrap';
import { LuUsers } from 'react-icons/lu';
import { SlArrowDown, SlArrowUp } from 'react-icons/sl';

import { getTeams } from 'services/api';

type instructionProps = {
    idUser?: number;
    instructorName?: string;
    instructorEmail?: string;
    instructorPhoto?: string;
};

const InstructionsContent = ({ entityType, idEntity, className = '' }) => {
    const [showInstructorList, setShowInstructorList] = useState(false);

    const [instructionsArray, setInstructionsArray] = useState<any>(null);

    useEffect(() => {
        if (instructionsArray === null) {
            getTeams({
                limit: 30,
                idTeam: idEntity,
                offset: 0,
            })
                .then((res) => {
                    if (res.data.result && res.data.result.length > 0) {
                        setInstructionsArray(res.data.result);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    }, [idEntity]);

    return (
        <>
            {entityType === EntityTypeEnum.TEAM && instructionsArray && instructionsArray.length > 0 && (
                <div className={`interaction-instructor-list ${className}`}>
                    <Button
                        className="interaction-instructor-button"
                        onClick={() => setShowInstructorList(!showInstructorList)}
                    >
                        <LuUsers /> {instructionsArray.length} Instrutor{instructionsArray.length > 1 ? 'es' : ''}
                        {!showInstructorList ? <SlArrowDown /> : <SlArrowUp />}
                    </Button>

                    {showInstructorList && (
                        <>
                            <div className="base-instructor-hit" onClick={() => setShowInstructorList(false)}></div>
                            <div className="base-instructor-list">
                                {instructionsArray.map((it) => {
                                    const firstLetter = it.instructorName ? it.instructorName.charAt(0) : '';

                                    return (
                                        <div className="instructor-item" key={it.idUser}>
                                            <div className="avtContainer">
                                                {it.instructorPhoto ? (
                                                    <img
                                                        src={it.instructorPhoto}
                                                        className="avatarImg"
                                                        alt={it.instructorName}
                                                    />
                                                ) : (
                                                    <div className="avatarTxt">{firstLetter}</div>
                                                )}
                                            </div>
                                            <div className="nameContainer">{it.instructorName}</div>
                                        </div>
                                    );
                                })}
                            </div>
                        </>
                    )}
                </div>
            )}
        </>
    );
};

export default InstructionsContent;